module Dialog {
    export function OpenModal(title: string, btnTitle: string, path: string, type: string = "", size: string = "modal-lg") {
        // add loader
        PlsWait.ShowLoader(true);

        // Apply modal size
        $("#ScriptModal .modal-dialog")
            .removeClass("modal-sm modal-lg modal-xl modal-xxl")
            .toggleClass(size, size !== "");

        $("#ScriptModalTitle").html(title);
        $("#btnScriptModal").text(btnTitle);

        (btnTitle != '') ? $("#btnScriptModal").show() : $("#btnScriptModal").hide();
        if (type != '') $("#btnScriptModal").show().off('click').on('click', function () { $("#btnAdministration").off('click').click(); });

        // Clear previous content so a failed load never shows stale markup
        $("#ScriptModalBody").empty();

        $("#ScriptModalBody").load(path, () => {
            // remove loader
            PlsWait.ShowLoader(false);

            $("#btnScriptModal").prop("disabled", false);
            $("#ScriptModal").modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            }).modal('show');
        });

        // Ensure backdrop and body class are always cleaned up on close,
        // but only when no other modals remain open.
        $("#ScriptModal").off("hidden.bs.modal.cleanup").on("hidden.bs.modal.cleanup", function () {
            var openModals = $(".modal.show").length;
            if (openModals === 0) {
                $(".modal-backdrop").remove();
                $("body").removeClass("modal-open").css({ "padding-right": "", "overflow": "" });
            }
        });
    }

    export function OpenDetailsModal(title: string, path: string, size: string = "modal-lg") {
        PlsWait.ShowLoader(true);

        $("#ScriptDetailsModal .modal-dialog")
            .removeClass("modal-sm modal-lg modal-xl modal-xxl")
            .toggleClass(size, size !== "");

        $("#ScriptDetailsModalTitleText").text(title);
        $("#btnScriptDetailsModal").hide();

        $("#ScriptDetailsModalBody").empty();

        $("#ScriptDetailsModalBody").load(path, (response, status, xhr) => {
            PlsWait.ShowLoader(false);

            if (status === "error") {
                const msg = xhr && xhr.statusText ? xhr.statusText : "Nepoznata greska";
                $("#ScriptDetailsModalBody").html(`<div class="alert alert-danger" role="alert">Neuspjelo ucitavanje sadrzaja: ${msg}</div>`);
            }

            $("#ScriptDetailsModal").modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            }).modal('show');
        });

        $("#ScriptDetailsModal").off("hidden.bs.modal.cleanup").on("hidden.bs.modal.cleanup", function () {
            var openModals = $(".modal.show").length;
            if (openModals === 0) {
                $(".modal-backdrop").remove();
                $("body").removeClass("modal-open").css({ "padding-right": "", "overflow": "" });
            }
        });
    }

    export function ConfirmDialog(title: string, message: string, onConfirm: () => void, confirmText: string = "Potvrdi", onCancel?: () => void, cancelText: string = "Odustani")
    {
        $("#ConfirmModalTitle").text(title);
        $("#ConfirmModalBody").html(message);
        $("#ConfirmModalYes").text(confirmText);

        const $cancelBtn = $("#ConfirmModalNo");
        if (onCancel) {
            $cancelBtn.text(cancelText).show().off("click").on("click", () => {
                $("#ConfirmModal").modal("hide");
                onCancel();
            });
        } else {
            $cancelBtn.hide().off("click");
        }

        $("#ConfirmModalYes").off("click").on("click", () => {
            $("#ConfirmModal").modal("hide");
            onConfirm();
        });

        $("#ConfirmModal").modal({
            backdrop: "static",
            keyboard: false
        });
    }

    export function InfoDialog(title: string, message: string) {
        $("#InfoModalTitle").text(title);
        $("#InfoModalBody").html(message);

        $("#InfoModal").modal({
            backdrop: "static",
            keyboard: false
        });
    }
}